import './scss/style.scss';
import login from './js/login';
import lostpassword from './js/lostpassword';

import account from './ts/account';
import product from './ts/product';
import checkout from './ts/checkout';
import resetpass from './ts/resetpass';
import register from './ts/register';
import reset from './ts/reset';

(async () => {
    await account();
    await checkout();
    await login();
    await register();
    await lostpassword();
    await product();
    await resetpass();
    await reset();
})();